import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles( {
  container : ( props ) => ( {
    position : props.relative ? 'relative' : 'absolute',
    top : 0,
    left : 0,
    right : 0,
    bottom : 0,
    display : 'flex',
    zIndex : 0,
    flexDirection : props.horizontal ? 'row' : 'column',
  } ),
  area : {
    flex : 1,
    position : 'relative',
    overflow : 'auto',
  },
  header : {
    position : 'relative',
  },
  footer : {
    position : 'relative',
  },
} )

export default function Container( props ) {
  const {
    header, area, footer, relative, children,
  } = props

  const classes = useStyles( props )

  if ( header ) {
    return (
      <div className={classes.header}>
        {children}
      </div>
    )
  }

  if ( footer ) {
    return (
      <div className={classes.footer}>
        {children}
      </div>
    )
  }

  if ( area ) {
    return (
      <div className={classes.area}>
        {children}
      </div>
    )
  }

  return (
    <div className={classes.container}>
      {children}
    </div>
  )
}
